// extracted by mini-css-extract-plugin
export default {"Component":"DefaultLayout_Component__-frpy","ResetBackground":"DefaultLayout_ResetBackground__AOLpl","Sider":"DefaultLayout_Sider__Zl76Q"};